import { render, staticRenderFns } from "./ItemHeader.vue?vue&type=template&id=557f898f"
import script from "./ItemHeader.vue?vue&type=script&lang=js"
export * from "./ItemHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports